import { render, staticRenderFns } from "./CardCollapse.vue?vue&type=template&id=427d8e81&scoped=true"
import script from "./CardCollapse.vue?vue&type=script&lang=js"
export * from "./CardCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d8e81",
  null
  
)

export default component.exports